import React from "react";
import {
  // Box,
  Button,
  DialogContent,
  // IconButton,
  makeStyles,
} from "@material-ui/core";
// import clsx from "clsx";
// Local
import {
  CancelSaveDialogActions,
  DateField,
  Field,
  PhoneField,
  SimpleDialog,
} from "../components";
import {
  //
  Form,
  useFormik,
  yup,
} from "../lib";
import { Appraisals } from "../services";
// import {
//   appraisalActions,
//   // authSelectors,
//   useAction,
//   // useSelector,
// } from "../state";

const useStyles = makeStyles(
  theme => ({
    content: {
      // Cause scrollbars to always be present.
      minHeight: "100%",
      "& h6": {
        marginTop: 0,
        fontSize: 16,
        fontWeight: 500,
      },
    },
    turninDate: {
      maxWidth: 200,
      paddingTop: 16,
      paddingBottom: 16,
    },
    contactHead: {
      fontSize: 16,
      fontWeight: 500,
      paddingTop: 32,
      paddingBottom: 16,
    },
    contactFields: {
      display: "flex",
      paddingBottom: 32,
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        paddingBottom: 0,
      },
    },
    flexRight: {
      marginLeft: 24,
    },
    flexRightLg: {
      marginLeft: 24,
      [theme.breakpoints.down("sm")]: {
        marginLeft: "unset",
        marginTop: 16,
      },
    },
  }),
  {
    classNamePrefix: "LeaseReturnDialog",
  },
);

/** @type {Appraisals.ContactInfo & {turninDate:Date|string|null}} */
const defaultValues = {
  // Location details
  address: "",
  turninDate: null,
  // Contact details
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
};

const validationSchema = yup.object({
  address: yup.string().required("Address required."),
  turninDate: yup.date().nullable().required("Date required."),
  firstName: yup.string(),
  lastName: yup.string(),
  email: yup.string().email(),
  phone: yup.string(),
});

export const LeaseReturnDialog = React.memo(
  /**
   * @param {{
   * onClose:Function;
   * onSubmit:(values:any) => Promise<void>;
   * title?: string;
   * }} param0
   */
  function LeaseReturnDialog({ onClose, onSubmit, title = "Returned" }) {
    const classes = useStyles();

    const [busy, setBusy] = React.useState(false);

    const frm = useFormik({
      enableReinitialize: true,
      initialValues: defaultValues,
      validateOnChange: false,
      validateOnBlur: false,
      validationSchema: validationSchema,
      async onSubmit(values, helpers) {
        setBusy(true);
        try {
          // console.log("SUBMIT", values);
          await onSubmit(values);
        } catch (err) {
          console.log("" + err);
          window.alert("There was an error. Please try again.");
          setBusy(false);
        }
      },
    });
    const {
      isSubmitting,
      // getFieldHelpers,
      // values,
    } = frm;
    const loading = busy || isSubmitting;
    // const { ... } = values;

    return (
      <SimpleDialog
        className={classes.root}
        fullScreenMobile
        maxWidth="sm"
        onClose={onClose}
        open={true}
        title={title}
      >
        <Form form={frm}>
          <DialogContent className={classes.content}>
            <Field name="address" label="Address" autoFocus fullWidth />
            <div className={classes.turninDate}>
              <DateField name="turninDate" label="" />
            </div>
            <div className={classes.contactHead}>Contact</div>
            <div className={classes.contactFields}>
              <Field name="firstName" label="First name" />
              <Field
                name="lastName"
                label="Last name"
                className={classes.flexRightLg}
              />
            </div>
            <div className={classes.contactFields}>
              <Field name="email" label="Email" type="email" />
              <PhoneField
                name="phone"
                label="Phone number"
                className={classes.flexRightLg}
              />
            </div>
          </DialogContent>
          <CancelSaveDialogActions
            disabled={loading}
            onCancel={onClose}
            // saveLabel="Save"
            // topBorder
          />
        </Form>
      </SimpleDialog>
    );
  },
);

export const LeaseReturnButton = React.memo(
  /**
   * @param {{children:React.ReactNode,onChanged:Function,returned?:boolean}} param0
   */
  function LeaseReturnButton({ onChanged, returned, row }) {
    const [editing, setEditing] = React.useState(false);
    const onClick = React.useCallback(
      /** @param {React.SyntheticEvent<HTMLElement>} e */
      e => {
        if (e && e.preventDefault) e.preventDefault();
        setEditing(true);
      },
      [],
    );
    const onClose = React.useCallback(
      /**
       * @type {import("@material-ui/core").ModalProps['onClose']}
       */
      (e, reason) => {
        // if (reason === "backdropClick") {
        //   return;
        // }
        setEditing(false);
      },
      [],
    );

    const onSubmit = React.useCallback(
      /** @param {Appraisals.ContactInfo & {turninDate:Date|string|null;}} values */
      async values => {
        await Appraisals.returned(row.id, values);
        onClose();
        if (onChanged) {
          onChanged();
        }
      },
      [row.id, onChanged, onClose],
    );

    return (
      <>
        <Button color="secondary" onClick={onClick}>
          {returned ? "Returned" : "Return"}
        </Button>
        {editing && <LeaseReturnDialog onClose={onClose} onSubmit={onSubmit} />}
      </>
    );
  },
);
